import { ITEMTOKEN } from 'data/const'

export function getAccessToken() {
    const item = localStorage.getItem(ITEMTOKEN)
    try {
        const data = item ? JSON.parse(item) : null
        if (!data) return null
        return data.accessToken
    } catch {
        return null
    }
}
